<template>
  <div class="bb-handovers">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-handovers-header">
      <div class="bb-handovers-header-back" @click="goBack">
        <i class="icon-arrow-back bb-handovers-header-back__icon"/>
        <span class="bb-handovers-header-back__text">Back</span>
      </div>
      <h2 class="bb-handovers-header__title">{{title}}</h2>
    </div>
    <label class="bb-handovers-search">
      <input class="bb-handovers-search__input bb-input bb-input_search"
             type="text"
             @input="inputSearch"
             placeholder="Search">
      <i class="icon-search bb-handovers-search__icon"/>
    </label>
    <div class="bb-handovers-search__tags">
      <FilterByTags :tags="tags"
                    :filterTags="filterTags"
                    @setFilter="getHandoverList"
                    ownFilterName="own"
                    tagFilterName="tag"/>
    </div>
    <VuePerfectScrollbar class="bb-handovers-list"
                         ref="bbHandoverScroll"
                         :class="{'bb-handovers-list_pagination': fullData.totalPages > 1}"
                         v-if="handovers.length > 0">
      <div class="bb-handovers-list__empty bb-handovers-list__empty_top"/>
      <div class="bb-handovers-list-item"
           :class="{
             'bb-handovers-list-item_approved': handover.approved,
             'bb-handovers-list-item_last': index === handovers.length - 1
           }"
           v-for="(handover, index) in handovers"
           :key="handover.id">
        <div class="bb-handovers-list-item-approved">
          <CircleCheckbox :disabled="true" :value="handover.approved" v-if="handover.approved"/>
          <i class="icon-edit bb-icon bb-icon_accent bb-handovers-list-item-approved__edit"
             @click.stop="editHandover = handover"
             v-else/>
        </div>
        <div class="bb-handovers-list-item-info">
          <div class="bb-handovers-list-item-info__label">
            {{handover.fullName}}
          </div>
          <div class="bb-handovers-list-item-info__draft" v-if="!handover.approved">
            Draft
          </div>
        </div>
        <div class="bb-handovers-list-item-tags">
          <div class="bb-handovers-list-item-tags__item"
               v-for="tag in handover.tags"
               :key="tag.name + tag.id"
               @click="setSearchTag(tag)">
            {{tag.name}}
          </div>
        </div>
        <div class="bb-handovers-list-item-date">
          <div v-if="handover.approved">{{handover.formatDate}}</div>
          <DataPicker v-else
                      @setDate="setApprovedDate"
                      :obj="handover"
                      :default-date="new Date()"/>
        </div>
        <div class="bb-handovers-list-item-controls" @mouseleave="hideAllPopup">
          <template v-if="handover.approved">
            <i class="icon-donwload bb-icon bb-icon_accent"
               @click="downloadFile(handover.uploadFile)"/>
          </template>
          <template v-else>
            <div class="bb-handovers-list-item-controls-upload">
              <template v-if="currentFile.id !== handover.id">
                <input class="bb-handovers-list-item-controls-upload__input"
                       type="file"
                       @change="setFile($event, handover)"
                       title="">
                <i class="icon-upload bb-icon bb-icon_accent bb-handovers-list-item-controls-upload__icon"/>
              </template>
              <template v-else-if="!currentFile.status && currentFile.id === handover.id">
                <div class="bb-handovers-list-item-controls-upload-loader">
                  <div class="bb-handovers-list-item-controls-upload-loader__border">
                    <span class="bb-handovers-list-item-controls-upload-loader__progress"/>
                  </div>
                </div>
              </template>
              <template v-else-if="currentFile.status && currentFile.id === handover.id">
                <div>
                  <i class="icon-donwload bb-icon bb-icon_accent" @click="setFileControl($event, handover)"/>
                  <transition name="bounce">
                    <div class="bb-handovers-list-item-controls-delete bb-handovers-list-item-controls-delete_file"
                         v-if="fileToolbar === handover.id"
                         :style="{
                             position: filePosition.top ? 'fixed' : 'absolute',
                             top: filePosition.top + 30 + 'px',
                             left: filePosition.left - 125 + 'px'
                           }">
                      <span class="bb-handovers-list-item-controls-delete__filename"
                            @click="downloadFile(currentFile.file)">
                        {{fileName}}
                      </span>
                      <i class="bb-handovers-list-item-controls-delete__remove icon-cross" @click="clearFile"/>
                    </div>
                  </transition>
                </div>
              </template>
            </div>
            <i class="icon-trash-1 bb-icon bb-icon_red" @click="setHandoverDelete($event, handover)"/>
            <transition name="bounce">
              <div class="bb-handovers-list-item-controls-delete"
                   :style="{
                       position: deletePosition.top ? 'fixed' : 'absolute',
                       top: deletePosition.top + 30 + 'px',
                       left: deletePosition.left - 95 + 'px'
                     }"
                   v-if="deleteHandoverId === handover.id">
                <span class="bb-handovers-list-item-controls-delete__title">Are you sure?</span>
                <div class="bb-handovers-list-item-controls-delete-buttons">
                  <button class="bb-handovers-list-item-controls-delete-buttons__item bb-button" type="submit"
                          @click.stop="deleteHandover">Yes
                  </button>
                  <button class="bb-handovers-list-item-controls-delete-buttons__item bb-button" type="submit"
                          @click.stop="deleteHandoverId = false">No
                  </button>
                </div>
              </div>
            </transition>
            <button class="bb-button bb-handovers-list-item-controls__accept"
                    @mouseenter="hideAllPopup"
                    @click="approveHandover(handover)"
                    :disabled="currentFile.id !== handover.id || !currentFile.status">
              SAVE
            </button>
          </template>
        </div>
      </div>
    </VuePerfectScrollbar>
    <Pagination :data="fullData" :getQuery="getHandoverList" :limit="defLimit" class="bb-pagination"/>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="editHandover.id" @close="editHandover = {}" :without-padding="true">
        <ContactHandoverForm @close="editHandover = {}"
                             :type="editHandoverType"
                             :handover="editHandover"
                             :selectedDocuments="editHandover.clientDocuments"
                             @update="updateHandover"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import HandoverApi from '@/api/ContactHandover/api'
import UploadFileApi from '@/api/UploadFile/api'
import Pagination from '@/components/Main/Pagination/Pagination'
import CircleCheckbox from '@/components/Main/Inputs/CircleCheckbox'
import moment from 'moment'
import {find, findIndex, uniqBy, get, debounce, trim} from 'lodash'
import {docsTags, docsOwnTags} from '@/constants/documentTags'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import {handoverType} from '@/constants/handover'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ContactHandoverForm
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactHandovers/ContactHandoverForm/ContactHandoverForm'
import setFileData from '@/mixin/setFileData'
import {saveAs} from 'file-saver'
import b64toBlob from 'b64-to-blob'
import FilterByTags from '@/components/Main/FilterByTags/FilterByTags'

export default {
  name: 'ContactHandoversList',
  mixins: [setFileData],
  components: {
    FilterByTags,
    Pagination,
    CircleCheckbox,
    DataPicker,
    VuePerfectScrollbar,
    LoaderFly,
    ModalWindow,
    ContactHandoverForm
  },
  data () {
    return {
      filterTags: {
        tag: [],
        own: []
      },
      editHandover: {},
      fileToolbar: false,
      filePosition: {},
      deleteHandoverId: false,
      deletePosition: {},
      loaderRun: false,
      handovers: [],
      title: 'Handovers',
      tags: [],
      defLimit: 50,
      currentPage: 1,
      fullData: {},
      allTags: [],
      currentFile: {},
      openFileControls: false,
      searchKeys: '',
      filterByCount: '',
      filterByType: '',
      filterByOwn: '',
      filterByTag: '',
      crypt: true,
      files: {}
    }
  },
  computed: {
    fileName () {
      const label = get(this.currentFile, 'file.label', '')
      const name = get(this.currentFile, 'file.name', '')
      return name || label
    },
    editHandoverType () {
      /** @see docLocation for toType */
      const type = this.editHandover.handoverDefinition
      if (type === 1) {
        return handoverType.received
      } else if (type === 2) {
        return handoverType.returned
      }
    },
    clientInfo () {
      return this.$store.getters.clientInfo
    },
    getWithSearch () {
      return debounce(this.getHandoverList, 250)
    }
  },
  methods: {
    inputSearch (e) {
      const val = e.target.value
      const searchValue = trim(val.toLowerCase())
      this.searchKeys = searchValue || ''
      const count = searchValue.match(/\d+/gmi) || []
      this.filterByCount = count[0]
      const handover = 'handover'
      const received = 'return'
      const reg = new RegExp('^' + searchValue, 'gmi')
      if (searchValue.length > 2 && reg.test(handover)) {
        this.filterByType = 1
      } else if (searchValue.length > 2 && reg.test(received)) {
        this.filterByType = 2
      } else {
        this.filterByType = ''
      }
      this.getWithSearch({})
    },
    setInfoAboutHandover (handover) {
      handover.tags = this.getUniqTags(handover.clientDocuments)
      handover.formatDate = handover.date && handover.approved ? this.formattedDate(handover.date) : 'N/A'
      handover.fullName = (handover.handoverDefinition === 1 ? 'Handover ' : 'Return ') + handover.handoverCounter
      return handover
    },
    getHandoverList ({page, own, tag, stopScroll}) {
      this.loaderRun = true
      this.currentPage = page || this.currentPage
      this.filterByOwn = own || this.filterByOwn
      this.filterByTag = tag || this.filterByTag
      const client = this.clientInfo.id
      HandoverApi.getHandovers({
        limit: this.defLimit,
        page: this.currentPage,
        handoverCounter: this.filterByCount,
        handoverDefinition: this.filterByType,
        client,
        own: this.filterByOwn,
        tag: this.filterByTag
      })
        .then((resp) => {
          if (!stopScroll) this.scrollUp()
          const respUniqTags = resp.data.uniqueTags || []
          const uniqTags = respUniqTags.map(item => {
            return find(docsTags, {id: item}) || {}
          })
          this.tags = respUniqTags.length > 0 ? docsOwnTags.concat(uniqTags) : []
          this.loaderRun = false
          this.fullData = resp.data
          this.handovers = resp.data.handovers.map(item => {
            return this.setInfoAboutHandover(item)
          })
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    deleteHandover () {
      if (!this.deleteHandoverId) return
      const handoverIndex = findIndex(this.handovers, {id: this.deleteHandoverId})
      if (handoverIndex !== -1) {
        this.handovers.splice(handoverIndex, 1)
      }
      HandoverApi.deleteHandover(this.deleteHandoverId)
        .then((resp) => {
        })
        .catch((e) => {
          console.error(e)
        })
    },
    setFile (e, handover) {
      const file = e.target.files[0]
      e.target.value = ''
      this.currentFile = {
        id: handover.id,
        status: false,
        file: file
      }
      this.uploadFile(file)
    },
    uploadFile (fileData) {
      const file = this.setFileData(fileData)
      UploadFileApi.createFile(file, this.crypt)
        .then((resp) => {
          Object.assign(this.currentFile.file, resp.data)
          this.currentFile.status = true
        })
        .catch((err) => {
          console.error(err)
        })
    },
    hideAllPopup () {
      this.deleteHandoverId = false
      this.fileToolbar = false
    },
    approveHandover (handover) {
      const resultHandover = {
        id: handover.id,
        approved: true,
        client: handover.client.id,
        clientDocuments: handover.clientDocuments.map(item => item.id),
        company: handover.company,
        date: handover.approvedDate,
        handoverDefinition: handover.handoverDefinition,
        user: handover.user.id,
        confidant: handover.confidant,
        uploadFile: this.currentFile.file.id
      }
      HandoverApi.updateHandover(resultHandover)
        .then((resp) => {
          this.updateHandover(resp.data)
          this.getHandoverList({stopScroll: true})
          this.setDefaultCurrentFile()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    setDefaultCurrentFile () {
      this.currentFile = {
        id: '',
        status: false,
        file: {}
      }
    },
    setHandoverDelete (e, handover) {
      this.deletePosition = e.target.getBoundingClientRect()
      this.deleteHandoverId = handover.id
      this.fileToolbar = false
    },
    setFileControl (e, handover) {
      this.filePosition = e.target.getBoundingClientRect()
      this.fileToolbar = handover.id
      this.deleteHandoverId = false
    },
    clearFile () {
      const fileId = get(this.currentFile, 'file.id', '')
      if (fileId) UploadFileApi.deleteFile(fileId, this.crypt)
      this.setDefaultCurrentFile()
    },
    downloadFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file.id)
    },
    getFile (id, filename) {
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    updateHandover (handover) {
      const index = findIndex(this.handovers, {id: handover.id})
      if (index !== -1) {
        this.handovers.splice(index, 1, this.setInfoAboutHandover(handover))
      }
    },
    scrollUp () {
      const scroll = get(this.$refs, 'bbHandoverScroll.$el', '')
      if (!scroll) return
      scroll.scrollTop = 0
    },
    formattedDate (date) {
      return moment(date).format('DD/MM/YY')
    },
    getUniqTags (documents) {
      const tag = documents.map(doc => {
        const tag = find(docsTags, {id: doc.tag}) || {}
        return tag
      })
      const own = documents.map(doc => {
        const own = find(docsOwnTags, {id: doc.own}) || {}
        return own
      })
      const tags = [...uniqBy(tag, 'id'), ...uniqBy(own, 'id')]
      this.allTags.push(...tags)
      return tags
    },
    setApprovedDate (date, handover) {
      handover.approvedDate = date
    },
    setSearchTag (tag) {
      const index = this.filterTags[tag.type].indexOf(tag.id)
      if (index !== -1) {
        this.filterTags[tag.type].splice(index, 1)
      } else {
        this.filterTags[tag.type].push(tag.id)
      }
    },
    goBack () {
      this.$emit('close')
    }
  },
  beforeMount () {
    this.setDefaultCurrentFile()
    this.getHandoverList({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-handovers {
    @include global-font;
    min-width: 800px;

    &-header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 25px;
      color: $color-accent;

      &-back {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent-hover;
        }

        &__icon {
          font-size: 21px;
          margin-right: 2px;
        }

        &__text {
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
        }
      }

      &__title {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
      }
    }

    &-search {
      position: relative;
      display: flex;
      align-items: center;
      background: $color-white;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 6px;
      margin: 22px 25px 8px;

      &__tags {
        margin-left: 25px;
      }

      &__input {
        width: 100%;
      }

      &__icon {
        position: absolute;
        left: 13px;
        font-size: 15px;
        color: $color-silver;
      }
    }

    &-list {
      position: relative;
      display: grid;
      grid-gap: 7px;
      max-height: calc(100vh - 280px);
      padding: 0 25px;

      &_pagination {
        max-height: calc(100vh - 355px);
      }

      &__empty {
        position: sticky;
        width: 100%;
        height: 15px;
        background-color: $color-white;
        z-index: 10;

        &_top {
          top: 0
        }
      }

      &-item {
        display: grid;
        grid-template-columns: 21px 150px minmax(auto, 1fr) minmax(110px, 0.5fr) 171px;
        grid-gap: 10px;
        align-items: center;
        padding: 8px 20px;
        min-height: 52px;
        width: 100%;
        background: $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.05);
        border-radius: 5px;
        font-size: 13px;
        line-height: 16px;
        cursor: default;
        transition: 0.4s;

        &_last {
          margin-bottom: 7px;
        }

        &_approved {
          grid-template-columns: 21px 150px minmax(auto, 1fr) minmax(110px, 0.5fr) 58px;
        }

        &-approved {
          &__edit {
            font-size: 21px;
            width: 21px;
            height: 21px;
          }
        }

        &-info {
          display: flex;
          align-items: center;

          &__label {
            font-weight: 500;
            margin-right: 15px;
            margin-left: 9px;
          }

          &__draft {
            color: $color-jaffa;
            padding: 4px 6px;
            border: 1px solid rgba($color-jaffa, 0.14);
            box-sizing: border-box;
            border-radius: 4px;
          }
        }

        &-tags {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -10px -10px 0;

          &__item {
            padding: 4px 6px;
            background: rgba($color-accent, 0.14);
            border-radius: 4px;
            font-weight: 500;
            color: $color-accent;
            margin: 0 10px 10px 0;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
              color: $color-accent-hover;
              background: rgba($color-accent-hover, 0.14);
            }
          }
        }

        &-controls {
          display: grid;
          grid-template-columns: 25px 25px 105px;
          align-items: center;
          grid-column-gap: 8px;

          &__accept {
            min-width: 91px;
            margin-left: 14px;
            height: 36px;
          }

          &-upload {
            position: relative;
            width: 25px;
            height: 25px;
            transition: 0.3s;

            &:hover &__icon {
              &:after {
                background-color: $color-accent-hover
              }
            }

            &__input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 21px;
              opacity: 0;
              padding: 21px 21px 0 0;
              cursor: pointer;
              z-index: 3;
            }

            &-loader {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 25px;
              height: 25px;
              border-radius: 50%;
              background-color: $color-wild-sand;

              &__border {
                border: 1px solid $color-accent;
                box-sizing: border-box;
                border-radius: 16px;
                width: 15px;
                height: 5px;
              }

              &__progress {
                display: block;
                background-color: $color-accent;
                width: 50%;
                height: 100%;
                transition: .3s;
                animation: loader 3s linear infinite;
              }
            }
          }

          &-delete {
            position: absolute;
            top: 30px;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: $color-white;
            box-shadow: 0 0 15px rgba($color-black, 0.05);
            border-radius: 5px;
            z-index: 12;
            padding: 14px;
            width: 120px;
            color: $color-black;
            cursor: default;

            &_file {
              display: grid;
              grid-template-columns: 1fr 13px;
              align-items: start;
              grid-gap: 10px;
              font-size: 13px;
              width: 150px;
              word-break: break-word;
            }

            &__filename {
              cursor: pointer;
              transition: .3s;

              &:hover {
                opacity: 0.6;
              }
            }

            &__remove {
              cursor: pointer;
              color: $color-silver-chalice;
              border-radius: 2px;
              transition: .3s;

              &:hover {
                opacity: 0.6;
              }
            }

            &_top {
              bottom: 0;
              top: auto;
            }

            &__title {
              font-size: 14px;
              line-height: 17px;
            }

            &-buttons {
              display: grid;
              grid-template-columns: 39px 39px;
              grid-gap: 10px;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin-top: 13px;

              &__item {
                font-size: 12px;
                line-height: 14px;
                width: 39px;
                height: 26px;
              }
            }
          }
        }
      }
    }
  }

  @keyframes loader {
    from {
      width: 0;
    }

    to {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactHandovers/ContactHandoversList/ContactHandoversList.vue